<template>
  <div>
    <h3 class="modal-title"> {{ mode === 'edit' ? 'Update' : 'Add' }} Location</h3>
    <b-row>
      <b-col cols="12">
        <div>
          <b-form-group
            :class="{'error-input' : $v.company_location.name.$error}">
            <label for="text1"> Name </label>
            <j-input
              id="text1"
              v-model="$v.company_location.name.$model"
              placeholder="Name"/>
          </b-form-group>
          <b-form-group
            :class="{'error-input' : $v.company_location.code.$error}">
            <label for="text2"> Code </label>
            <j-input
              id="text2"
              v-model="$v.company_location.code.$model"
              placeholder="Code"/>
          </b-form-group>
          <b-form-group
            :class="{'error-input' : $v.company_location.type.$error}">
            <label for="text3"> Type </label>
            <j-single-select
              v-model="$v.company_location.type.$model"
              :options="typeOptions"
              placeholder="Select Type"
              value-format="object"/>
          </b-form-group>
          <b-form-group
            :class="{'error-input' : $v.company_location.pic_organigram.$error}">
            <label>PIC Position</label>
            <j-single-select
              v-model="$v.company_location.pic_organigram.$model"
              :is-async="true"
              :load-options="loadPositionOptions"
              placeholder="Select PIC"
              value-format="object"
              label="name"/>
          </b-form-group>
          <div>
            <b-button
              v-if="mode === 'edit'"
              class="btn red"
              @click="deleteLocation">
              Delete
            </b-button>
            <div class="float-right">
              <b-button
                class="btn"
                @click="closeModal">
                Cancel
              </b-button>
              <b-button
                v-if="mode === 'edit'"
                class="btn blue"
                @click="updateLocation">
                Update
              </b-button>
              <b-button
                v-else
                class="btn blue"
                @click="submit">
                Add
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import jApiPosition from '@/services/jApiPosition';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  validations: {
    company_location: {
      name: {
        required,
      },
      code: {
        required,
      },
      type: {
        required,
      },
      pic_organigram: {
        required,
      },
    },
  },
  props: {
    detail: {
      type: Object,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      company_location: {
        name: null,
        code: null,
        type: null,
        pic_organigram: null,
      },
      options: {
        icon: 'fa-map-marker',
        main_title: this.mode === 'create' ? 'Add Location' : 'Edit Location',
      },
      typeOptions: [
        {
          id: 'OFFICE',
          text: 'Office',
          is_delete: false,
        },
        {
          id: 'NON OFFICE',
          text: 'Non Office',
          is_delete: false,
        },
      ],
    };
  },
  created() {
    if (this.mode === 'edit') {
      this.company_location = {
        id: this.detail.id,
        name: this.detail.name,
        code: this.detail.code,
        type: {
          id: this.detail.type,
        },
        pic_organigram: {
          id: this.detail.organigram.id,
          label: this.detail.organigram.name,
        },
      };
    } else {
      this.company_location = {
        name: null,
        code: null,
        type: null,
        pic_organigram: null,
      };

      this.$v.company_location.$reset();
    }
  },
  methods: {
    ...mapActions('jStoreLocation', ['createCompanyLocation', 'companyDeleteLocation', 'companyUpdateLocation']),

    async submit() {
      this.$v.company_location.$touch();
      if (!this.$v.company_location.$error) {
        // eslint-disable-next-line camelcase
        const { name, code, type, pic_organigram } = this.company_location;
        const params = {
          name,
          code,
          type: type.id,
          pic_organigram_id: pic_organigram.id,
        };
        await this.createCompanyLocation(params);
        this.$emit('updated', true);
        this.closeModal();
      }
    },
    async updateLocation() {
      this.$v.company_location.$touch();
      if (!this.$v.company_location.$error) {
        // eslint-disable-next-line camelcase
        const { id, name, code, type, pic_organigram } = this.company_location;
        const params = {
          name,
          code,
          type: type.id,
          pic_organigram_id: pic_organigram.id,
        };
        await this.companyUpdateLocation({ id, req: params });
        this.$emit('updated', true);
        this.closeModal();
      }
    },
    deleteLocation() {
      this.$swal.fire({
        title: '<span style="color:#d2232a;font-size:1.25em;margin-bottom:10px">Delete<span>',
        html:
    '<p style="font-size:1em;"> Are you sure to delete this location?</p> ',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
    'Delete',
        confirmButtonAriaLabel: 'Thumbs up, great!',
        cancelButtonText:
    'Cancel',
        cancelButtonAriaLabel: 'Thumbs down',
        type: 'warning',
        confirmButtonColor: '#d2232a',
        cancelButtonColor: '#d33',
      }).then(async (result) => {
        if (result.value) {
          const params = {
            id: this.company_location.id,
          };
          await this.companyDeleteLocation(params);
          this.$emit('updated', true);
          this.closeModal();
        }
      });
    },
    closeModal() {
      this.company_location = {
        name: null,
        code: null,
        type: null,
        pic_organigram: null,
      };
      this.$v.company_location.$reset();
      this.$emit('close-modal', true);
    },
    loadPositionOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: 'id',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.data = this.getListPositions(reqData, callback);
      }
    },
    getListPositions(req, callback) {
      return jApiPosition.getListPosition(req)
        .then((res) => {
          if (typeof res.data.data !== 'undefined') {
            res.data.data.forEach((lab, index) => {
              if (!lab.name.replace(/\s/g, '').length) {
                // eslint-disable-next-line
                res.data.data[index].label = lab.email;
              } else {
                // eslint-disable-next-line
                res.data.data[index].label = lab.name;
              }
            });
            callback(null, res.data.data);
          }
          return res.data;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
  .button-action__company-location__create{
    float: right;
    margin-bottom: 50px;
  }

  .red{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/location/jFormCompanyLocation.vue